export const byProperty = <T extends Record<keyof T, unknown>>(
    array: T[],
    property: keyof T,
): Record<string, T> => {
    return array.reduce((record: Record<string, T>, element: T) => {
        record[String(element[property])] = element
        return record
    }, {})
}
